/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type OptimizeFieldSchemeEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const optimizeFieldSchemeEntryPoint: EntryPoint<OptimizeFieldSchemeEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<OptimizeFieldSchemeEntryPointComponent>(
			/* webpackChunkName: "async-jira-admin-pages-optimize-field-scheme-page", jiraSpaEntry: "async-jira-admin-pages-optimize-field-scheme-page" */ './OptimizeFieldSchemePage.tsx',
		),
		getPreloadProps: () => ({}),
	});
